<template>
  <div>
    <v-app-bar
      dense
      app
      flat>
      <v-app-bar-nav-icon @click.stop="toggleLeft" />

      <v-toolbar-title>{{ title }}</v-toolbar-title>

      <v-spacer />

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            color="black"
            v-on="on">
            <v-badge
              :value="!notify ? 0 : Object.keys(notify).length"
              :content="!notify ? 0 : Object.keys(notify).length"
              color="green"
              bordered
              overlap
            >
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <v-list
          width="200"
          class="nav-list">
          <v-list-item
            v-if="Object.keys(notify).length > 0"
            @click="notifyProgramari"
          >
            <v-list-item-title
            >Aveti {{ Object.keys(notify).length }} programari
            noi</v-list-item-title
            >
          </v-list-item>
          <v-list-item v-if="Object.keys(notify).length == 0">
            <v-list-item-title>Nu sunt notificari noi</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            color="black"
            v-on="on">
            <v-icon>mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list
          width="200"
          class="nav-list">
          <v-list-item to="/profil">
            <v-list-item-title>Profil</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="logout">
            <v-list-item-title>Iesire</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>
<script>
import { mapMutations, mapActions } from 'vuex'
import router from '@/router'
const firebase = require('../../firebaseConfig.js')
export default {
  data () {
    return {
      title: null,
      userid: localStorage.getItem('useruid'),
      token: localStorage.getItem('logout_token'),
      notify: []
    }
  },
  watch: {
    $route (val) {
      this.title = val.name
      firebase.database
        .ref('programari/medic-' + this.userid + '/latest')
        .once('value', (storedValue) => {
          if (storedValue.val() !== null) {
            this.notify = storedValue.val()
          } else {
            this.notify = []
          }
        })
        .then(function (data) {})
    }
  },
  methods: {
    ...mapMutations('App', ['setDrawer', 'toggleDrawer']),
    ...mapActions(['logOut']),
    toggleLeft () {
      this.setDrawer(!this.$store.state.App.drawer)
    },
    notifyProgramari () {
      router.push({ path: '/programari' })
      firebase.database
        .ref('programari/medic-' + this.userid + '/latest')
        .remove()
        .then(function () {
          console.log('Ok')
        })
    },
    logout () {
      router.push({ path: '/logout' })
      this.logOut({
        token: this.token
      })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/core/Toolbar.vue